import React from "react";

/**
 * Hook to define states related to configurations, templates, and pagination.
 */
export const useBackendStates = ({ name = "Backend states", logOther = false }) => {
    const [programStatus, setProgramStatus] = React.useState(null);

    const [resourceStatistics, setResourceStatistics] = React.useState(null);
    const [transcriptStatistics, setTranscriptStatistics] = React.useState(null);
    const [authorStatistics, setAuthorStatistics] = React.useState(null);
    const [highlightStatistics, setHighlightStatistics] = React.useState(null);
    const statisticsLibraryIdRef = React.useRef(null);
    const [statisticsLibraryId, setStatisticsLibraryIdState] = React.useState(null);

    const setStatisticsLibraryId = (libraryId) => {
        statisticsLibraryIdRef.current = libraryId;
        setStatisticsLibraryIdState(libraryId);
        setResourceStatistics(null);
        setTranscriptStatistics(null);
        setAuthorStatistics(null);
        setHighlightStatistics(null);
    };

    React.useEffect(() => {
        if (!logOther) return;

        console.log(`=== ${name} other ===`);
        console.log("programStatus", JSON.parse(JSON.stringify(programStatus)));
        console.log("\n");
    }, [programStatus]);

    return {
        // Other.
        programStatus,
        setProgramStatus,

        resourceStatistics,
        setResourceStatistics,
        transcriptStatistics,
        setTranscriptStatistics,
        authorStatistics,
        setAuthorStatistics,
        highlightStatistics,
        setHighlightStatistics,
        statisticsLibraryId,
        statisticsLibraryIdRef,
        setStatisticsLibraryId
    };
};
